import React from 'react';
import { getConsultationDisplayStatus } from './utils/consultationStatus';
import './ConsultationStatusBadge.css';

/**
 * Badge statut consultation — file d’attente, en cours, terminée, annulée.
 */
export default function ConsultationStatusBadge({ consultation, labels, compact = false, className = '' }) {
  const meta = getConsultationDisplayStatus(consultation, labels);

  if (!consultation || meta.label === '—') {
    return <span className="co-status-badge co-status-badge--neutral">—</span>;
  }

  return (
    <span
      className={[
        'co-status-badge',
        `co-status-badge--${meta.tone}`,
        meta.pulse ? 'co-status-badge--pulse' : '',
        compact ? 'co-status-badge--compact' : '',
        className
      ]
        .filter(Boolean)
        .join(' ')}
      title={meta.hint || undefined}
    >
      <span className="co-status-badge__dot" aria-hidden />
      <span className="co-status-badge__text">
        <span className="co-status-badge__label">{meta.label}</span>
        {!compact && meta.hint ? (
          <span className="co-status-badge__hint">{meta.hint}</span>
        ) : null}
      </span>
    </span>
  );
}
